import Classnames from 'classnames'

import { useRecoilState, useRecoilValue, useRecoilCallback } from 'recoil'
import {
  isBuilder,
  screen,
  screenOpen,
  editSectionId,
  editSectionWrapperId,
} from '@/store/builder/store'
import { section } from '@/store/template/section'

import { RiSettings5Line } from 'react-icons/ri'

function TextCallout({ id, contentID, sectionData, wrapperId }) {
  const isBuilderApp = useRecoilValue(isBuilder)
  const [getSreen, setScreen] = useRecoilState(screen)
  const [getScreenOpen, setScreenOpen] = useRecoilState(screenOpen)
  const [getEditSectionId, setEditSectionId] = useRecoilState(editSectionId)
  const [getEditSectionWrapperId, setEditSectionWrapperId] =
    useRecoilState(editSectionWrapperId)

  const openEditor = () => {
    if (isBuilderApp) {
      setScreen('editsection')
      setScreenOpen(true)
      setEditSectionId(id)
      setEditSectionWrapperId(wrapperId)
    }
  }

  const gotoLink = () => {
    if (isBuilderApp) {
      setScreen('editsection')
      setScreenOpen(true)
      setEditSectionId(id)
      setEditSectionWrapperId(wrapperId)
    } else {
      // open to link if has link
      if (sectionData.data.buttonlink) {
        window.open(sectionData.data.buttonlink, '_blank')
        // analytics.track('Text Callout Button Link Click')
      }
    }
  }

  return (
    <div
      onClick={openEditor}
      className={Classnames(
        'flex flex-col justify-center boxBody boxBodyTextCallout py-5 h-full  relative',
        {
          'items-center': sectionData.data.align == 'center',
          'text-center': sectionData.data.align == 'center',
          'items-end': sectionData.data.align == 'right',
          'text-right': sectionData.data.align == 'right',
        }
      )}
      style={{
        marginTop: sectionData.data.vert_padding
          ? sectionData.data.vert_padding + '%'
          : '0%',
        marginBottom: sectionData.data.vert_padding
          ? sectionData.data.vert_padding + '%'
          : '0%',
      }}
    >
      {/* edit icon */}
      {isBuilderApp && (
        <div
          onClick={openEditor}
          className="absolute top-3 right-3 opacity-50 hover:opacity-100 hover:shadow p-1 text-lg rounded  hover:bg-blue-500 hover:text-white cursor-pointer"
        >
          <RiSettings5Line />
        </div>
      )}

      {sectionData.data.label && (
        <div className="textCalloutLabel mb-5 mt-5">
          <div
            className={Classnames(
              ' text-base rounded-sm  font-medium  inline-flex',
              {
                'bg-blue-50 text-blue-700 p-1 px-3':
                  sectionData.data.labelcolor.id == 'blue',
                'bg-green-50 text-green-700 p-1 px-3':
                  sectionData.data.labelcolor.id == 'green',
                'bg-red-50 text-red-700 p-1 px-3':
                  sectionData.data.labelcolor.id == 'red',
                'bg-purple-50 text-purple-700 p-1 px-3':
                  sectionData.data.labelcolor.id == 'purple',
                'bg-yellow-50 text-yellow-700 p-1 px-3':
                  sectionData.data.labelcolor.id == 'yellow',
                'bg-gray-50 text-gray-700 p-1 px-3':
                  sectionData.data.labelcolor.id == 'gray',
              }
            )}
            style={{
              fontSize: sectionData.data.label_size
                ? sectionData.data.label_size + 'px'
                : '16px',
            }}
          >
            {sectionData.data.label}
          </div>
        </div>
      )}

      <h1
        className="textCalloutHeadline font-bold leading-tight"
        style={{
          fontSize: sectionData.data.headline_size
            ? sectionData.data.headline_size + 'px'
            : '36px',
          lineHeight: sectionData.data.headline_lineheight
            ? sectionData.data.headline_lineheight + 'px'
            : 'auto',
          marginLeft: sectionData.data.side_padding
            ? sectionData.data.side_padding + '%'
            : '0%',
          marginRight: sectionData.data.side_padding
            ? sectionData.data.side_padding + '%'
            : '0%',
        }}
      >
        {sectionData.title}
      </h1>

      {sectionData.prompt && (
        <h3
          className={Classnames('textCalloutSubHeadline mt-3 ', {
            'mb-5': sectionData.data.button,
          })}
          style={{
            fontSize: sectionData.data.subtitle_size
              ? sectionData.data.subtitle_size + 'px'
              : '18px',
            lineHeight: sectionData.data.subtitle_lineheight
              ? sectionData.data.subtitle_lineheight + 'px'
              : 'auto',
            marginLeft: sectionData.data.subtitle_side_padding
              ? sectionData.data.subtitle_side_padding + '%'
              : '0%',
            marginRight: sectionData.data.subtitle_side_padding
              ? sectionData.data.subtitle_side_padding + '%'
              : '0%',
          }}
        >
          {sectionData.prompt}
        </h3>
      )}

      {sectionData.data.button && (
        <div className="textCalloutButton">
          <button
            onClick={gotoLink}
            className={`py-3 px-5 font-bold rounded  bg-${sectionData.data.buttoncolor.id}-500 text-white hover:bg-${sectionData.data.buttoncolor.id}-600`}
            style={{
              fontSize: sectionData.data.button_size
                ? sectionData.data.button_size + 'px'
                : '18px',
            }}
          >
            {sectionData.data.button}
          </button>
        </div>
      )}
    </div>
  )
}

export default TextCallout
